var React = require('react');

function IcoChat (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.78 10.39c-1.82.79-3.03 2.22-3.03 3.86 0 .95.41 1.83 1.11 2.56l-1.11 1.94H9c1.9 0 3.59-.61 4.74-1.57M8.75 9.75c0 2.49 2.8 4.5 6.25 4.5h6.25l-1.11-1.94c.7-.73 1.11-1.61 1.11-2.56 0-2.49-2.8-4.5-6.25-4.5s-6.25 2.01-6.25 4.5z","fill":"none","stroke":"#fff","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

IcoChat.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = IcoChat;

IcoChat.default = IcoChat;
